import { Component, OnInit } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skipWhile, switchMap, take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { FilialService } from 'src/app/core/services/filial.service';
import { InventarService } from 'src/app/core/services/inventar.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { saveAs } from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { WorkerService } from 'src/app/core/services/worker.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { ICompany } from 'src/app/core/models/company.model';

@Component({
  selector: 'app-filial-profile',
  templateUrl: './filial-profile.component.html',
  styleUrls: ['./filial-profile.component.css'],
})
export class FilialProfileComponent implements OnInit {
  companyId: string;
  filialId: string;
  filial: any;
  toggleNewInventory = false;
  toggleDeleteInventar = false;
  toggleFinishInfo = false;
  inventar: any;
  currentUser: any;
  isLoading = false;
  company: any;
  toggleImportCSV = false;
  isLoadingForm = false;
  workers: any = [];
  selectedWorkers = [];
  inventars: any;

  searchControl = new FormControl();
  formCtrlSub: Subscription;

  searchParam: string;
  companies: ICompany[];

  isAllIventars: boolean = false;

  page = 1;
  perPage = 10;

  vinSearch = "";
  referenceSearch = "";

  vinFormControl = new FormControl("",{ updateOn: "blur" });
  referenceFormControl = new FormControl("",{ updateOn: "blur" });

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private filialService: FilialService,
    private inventarService: InventarService,
    private toastr: ToastrService,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private translate: TranslateService,
    private http: HttpClient,
    private workerService: WorkerService,
    private companyService: CompanyService
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    if (this.currentUser.role.name === 'root' && this.router.url.includes('/root/inventars')) {
      this.isAllIventars = true;
    }

    this.route.parent.parent.parent.params.subscribe((res) => {
      this.companyId = res.id || this.currentUser.companyId;
    });

    if (this.currentUser.role.name === Role.ROOT) {
      this.route.parent.parent.parent.data.subscribe((res) => {
        this.company = res.company;
      });
    }

    this.filialId = this.route.snapshot.params.filialId;

    if (this.currentUser.role.name === Role.WORKER) {
      this.loadWorkerInventars();
    } else {
      this.loadFilial();
      if (this.isAllIventars) {
        this.companyService.getCompanies().subscribe(res => {
          this.companies = res;
        })
      } else {
        this.loadWorkers()
      }
    }

    const component = this;

    this.vinFormControl.updateOn

    this.vinFormControl.valueChanges.subscribe(() => {
      const search = component.vinFormControl.value
      component.vinSearch = search;
      component.refreshInventarsSearch();
    });

    this.referenceFormControl.valueChanges.subscribe(() => {
      const search = component.referenceFormControl.value
      component.referenceSearch = search;
      component.refreshInventarsSearch();
    });
  }

  ngAfterViewInit() {
    if (
      this.isAllIventars
    ) {
      this.formCtrlSub = this.searchControl.valueChanges
        .pipe(
          debounceTime(800),
          distinctUntilChanged(),
          tap((value) => {
            this.isLoading = true;
            this.searchParam = value;
          }),
          switchMap((changedValue) => this.getFilials())
        )
        .subscribe((res) => {
          this.isLoading = false;
          this.page = 1;
          this.inventars = res.inventars;
        });
    }
  }

  loadWorkerInventars() {
    this.isLoading = true;
    this.workerService
      .getWorkerAssignedInventars(this.currentUser.id)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.inventars = res;
        },
        (err) => { }
      );
  }

  loadWorkers() {
    this.workerService.getCompanyWorkers(this.companyId).subscribe(
      (res) => {
        this.workers = res;
      },
      (err) => { }
    );
  }


  onSelectionChange(selectedOption: any) {
    if (selectedOption) {
      this.companyId = selectedOption.id;
    } else {
      this.companyId = null;
    }
    this.page = 1;
    this.loadFilial();
  }

  getFilials(): Observable<any> {
    if (this.isAllIventars) {
      return this.inventarService.getAllInventars(this.page, this.perPage, this.companyId, this.searchParam);
    } else {
      return this.filialService.getFilialById(this.companyId, this.filialId);
    }
  }

  loadFilial() {
    this.isLoading = true;
    this.getFilials()
      .subscribe((res) => {
        if (this.isAllIventars) {
          this.isLoading = false;
          this.inventars = res;
          console.log(res)
        } else {
          this.isLoading = false;
          this.filial = res;
          this.inventars = this.filial.inventars;
          this.breadcrumbService.set('@companyName', this.company?.name);
          this.breadcrumbService.set('@filialName', this.filial.name);
        }

      });
  }

  onAddInventory() {
    this.inventar = {};
    this.inventar.isNew = true;
    this.toggleNewInventory = true;
  }

  onEdit(inventar) {
    this.inventar = inventar;
    this.inventar.isNew = false;
    this.toggleNewInventory = true;
  }

  onDownloadCsv(inventar) {
    this.inventarService.downloadInventarCsv(inventar.id).subscribe(
      (res) => {
        const blob = new Blob([res], { type: 'text/csv' });
        const fileName = inventar.name + '.csv';
        saveAs(blob, fileName);
      },
      (err) => {
        this.toastr.error('Error CSV Downloading');
        console.log(err);
      }
    );
  }

  onCopyInventar(inventar) {
    this.inventarService.copyInventar(inventar.id, this.filialId).subscribe(
      (res) => {
        this.inventars = res;
      },
      (err) => {
        this.toastr.error('Error copying the inventar');
        console.log(err);
      }
    );
  }

  onDelete(inventar) {
    this.inventar = inventar;
    this.toggleDeleteInventar = true;
  }

  /**
   * Add new inventory
   * @param form
   * @returns
   */
  addInventory(form: NgForm) {
    let body = {};

    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return false;
    }

    Object.entries(form.form.value).forEach(([key, value], index) => {
      if (value) {
        if (key === "status") {
          body[key] = value ? "permanent" : "active";
        } else {
          body[key] = value;
        }
      }
    });

    this.isLoadingForm = true;

    this.inventarService.createInventar(this.filialId, body).subscribe(
      (res) => {
        this.translate
          .get('filials.filial.inventoryCreated')
          .subscribe((res: string) => {
            this.toastr.success(res);
          });

        const workersIds = this.selectedWorkers.map((w) => w.id);

        this.inventarService
          .assignWorkersToFilialInventar(this.filialId, res.id, workersIds)
          .subscribe(
            (res) => {
              this.isLoadingForm = false;
              this.toggleNewInventory = false;
              this.loadFilial();
              this.selectedWorkers = [];
              this.toastr.success('Success');
            },
            (err) => { }
          );
      },
      (err) => {
        this.isLoadingForm = false;
      }
    );
  }

  /**
   * Edit selecteed inventar
   * @param form - data for edit
   * @returns
   */
  editInventar(form: NgForm) {
    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return;
    }

    const editData = form.form.value;

    const body = {};

    Object.keys(this.inventar).forEach((key) => {
      if (key in editData) {
        if (this.inventar[key] !== editData[key]) {
          if (editData[key]) {
            if (key === "status") {
              body[key] = editData[key] ? "permanent" : "active";
            } else {
              body[key] = editData[key] === '' ? null : editData[key];
            }
          }
        }
      }
    });

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      return;
    }

    this.isLoadingForm = true;

    this.inventarService
      .editInventar(this.inventar.filialId, this.inventar.id, body)
      .subscribe(
        (res) => {
          this.translate
            .get('filials.filial.inventoryEdited')
            .subscribe((res: string) => {
              this.toastr.success(res);
            });

          this.isLoadingForm = false;
          this.toggleNewInventory = false;
          this.loadFilial();
          this.inventar = {};
        },
        (err) => {
          this.isLoadingForm = false;
        }
      );
  }

  /**
   * delete selected inventar
   */
  deleteInventar() {
    this.inventarService
      .deleteInventar(this.inventar.filialId, this.inventar.id)
      .subscribe(
        (res) => {
          this.toggleDeleteInventar = false;
          this.inventar = {};
          this.translate
            .get('filials.filial.inventoryDeleted')
            .subscribe((res: string) => {
              this.toastr.success(res);
            });
          this.loadFilial();
        },
        (err) => {
          this.inventar = {};
          this.toggleNewInventory = false;
        }
      );
  }

  /**
   * Open modal for finish inventar
   * @param inventar - selected inventar
   */
  onFinish(inventar) {
    this.inventar = inventar;
    this.toggleFinishInfo = true;
  }

  /**
   * Change inventar status to finished
   */
  finishInventar() {
    let body = {
      status: "finished"
    };

    this.toggleFinishInfo = false;

    this.inventarService
      .editInventar(this.inventar.filialId, this.inventar.id, body)
      .subscribe(
        (res) => {
          this.translate
            .get('filials.filial.inventoryFinished', {
              name: this.inventar.name,
            })
            .subscribe((res: string) => {
              this.toastr.success(res);
            });
          this.loadFilial();
        },
        (err) => {
          this.toastr.error(err.error.description);
        }
      );
  }

  /**
   * Change inventar status to progress
   */
  openInventar(form: NgForm) {
    let body = {
      status: 'active',
      reason: form.form.value.reason
    };
    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return false;
    }
    this.toggleFinishInfo = false;
    this.inventarService
      .editInventar(this.inventar.filialId, this.inventar.id, body)
      .subscribe(
        (res) => {
          this.translate
            .get('filials.filial.inProgress', {
              name: this.inventar.name,
            })
            .subscribe((res: string) => {
              this.toastr.success(res);
            });
          this.loadFilial();
        },
        (err) => {
          this.toastr.error(err.error.description);
        }
      );
  }

  onImportCsv(inventar) {
    this.toggleImportCSV = true;
    this.inventar = inventar;
  }

  removeInputValue(event) {
    event.target.value = null;
  }

  csvFile = null;
  fileChangeEvent(event: any): void {
    this.csvFile = event.target.files[0];
    let url = URL.createObjectURL(this.csvFile);

    // var reader = new FileReader();
    // reader.onload = function () {
    //   console.log(reader.result)
    // };
    // // start reading the file. When it is done, calls the onload event defined above.
    // reader.readAsBinaryString(this.csvFile);

    this.http.get(url, { responseType: 'text' }).subscribe(
      (data) => {
        console.log(data);
        let csvToRowArray = data.split('\n');
        for (let index = 1; index < csvToRowArray.length - 1; index++) {
          let row = csvToRowArray[index].split(',');
          // this.userArray.push(new User( parseInt( row[0], 10), row[1], row[2].trim()));
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  selectWorker(event) {
    const workerId = event.target.value;
    const isDuplicate = this.selectedWorkers.some((w) => w.id === workerId);

    if (!isDuplicate) {
      this.selectedWorkers.push(this.workers.find((w) => w.id === workerId));
    }
  }

  removeWorker(worker) {
    this.selectedWorkers = this.selectedWorkers.filter(
      (w) => w.id !== worker.id
    );
  }

  jumpToPage(event: any) {
    this.page = event;
    this.loadFilial();
  }

  refreshInventarsSearch() {
    this.inventarService.getAllFilialInventarsSearch(this.filialId, this.vinSearch, this.referenceSearch).subscribe((res) => {
      this.inventars = res;
    });
  }
}